import { HttpErrorResponse } from "@angular/common/http";
import { Action } from "@ngrx/store";
import {
  CourseFeedback,
  CourseFeedbackResponse,
} from "src/app/shared/interfaces/feedback-course";
import { Guid } from "src/app/shared/types/guid";

export const FEEDBACK_COURSE_LOAD = "[Feedback Course] Load";
export const FEEDBACK_COURSE_SUCCESS = "[Feedback Course] Load success";
export const FEEDBACK_COURSE_FAIL = "[Feedback Course] Load fail";

export class FeedbackCourseLoad implements Action {
  readonly type = FEEDBACK_COURSE_LOAD;
  constructor(
    public CourseId: Guid,
    public payload: CourseFeedback,
  ) {}
}

export class FeedbackCourseSuccess implements Action {
  readonly type = FEEDBACK_COURSE_SUCCESS;
  constructor(public feedback: CourseFeedbackResponse) {}
}

export class FeedbackCourseFailure implements Action {
  readonly type = FEEDBACK_COURSE_FAIL;
  constructor(public error: HttpErrorResponse) {}
}

export type FeedbackCourseActions =
  | FeedbackCourseLoad
  | FeedbackCourseSuccess
  | FeedbackCourseFailure;
